// Admin access configuration for Crypto Audit Service.
// The admin panel is accessible ONLY to the accounts listed below.
//
// Admin access is matched primarily by EMAIL (the address you sign in with),
// because that is stable and unambiguous. The legacy username check is kept
// as a fallback so existing setups keep working.

// Email(s) that should have admin access. Add more emails to this list if needed.
export const ADMIN_EMAILS = [
  'chumponbase@gmail.com',
]

// Legacy username-based admin (fallback only).
export const ADMIN_USERNAME = 'MandoxAdmin'

type LumiUserLike = {
  userName?: string | null
  email?: string | null
} | null | undefined

export function isAdmin(user: LumiUserLike): boolean {
  if (!user) return false

  const email = user.email?.trim().toLowerCase()
  if (email && ADMIN_EMAILS.some(e => e.toLowerCase() === email)) {
    return true
  }

  const userName = user.userName?.trim().toLowerCase()
  if (userName && userName === ADMIN_USERNAME.toLowerCase()) {
    return true
  }

  return false
}
